/**
 * Created by zcr on 2018/5/5.
 */
// 获取状态信息
export default {
  showState(state) {
    // console.log(state.msg)
    return state.msg;
  },
};
